import React, { useEffect, useState } from 'react';
import { getCityWithPreposition } from '../../../../utils/functions/getCityWithPreposition';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType } from '../../../../context/AppContext';
import CompanyName from '../../../commonComponents/CompanyName';
import StatusSignature from '../../../commonComponents/StatusSignature';
import { StatusSignatureType } from '../../../../static/types/commonTypes/statusSignatureType';
import TheSociety from '../../../commonComponents/TheSociety';
import HeadOfficeAddress from '../../../commonComponents/HeadOfficeAddress';
import { HeadOfficeAddressType } from '../../../../static/types/commonTypes/headOfficeAddressType';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import { ManagerType } from '../../../../static/types/commonTypes/managerType';
import ManagerList from '../../../commonComponents/ManagerList';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';
import TabsNavigation from '../OngletforAssiste';


interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const CreationEURL: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected,
}) => {

    const {
        managers, setManagers,
        managersValidity, setManagersValidity,
        managersChecked, setManagersChecked,

        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        statusSignature, setStatusSignature,
        statusSignatureValidity, setStatusSignatureValidity,
        statusSignatureChecked, setStatusSignatureChecked,

        theSociety, setTheSociety,
        theSocietyValidity, setTheSocietyValidity,
        theSocietyChecked, setTheSocietyChecked,

        headOfficeAddress, setHeadOfficeAddress,
        headOfficeAddressValidity, setHeadOfficeAddressValidity,
        headOfficeAddressChecked, setHeadOfficeAddressChecked,

        lastTab, setLastTab,
        draftFormData, setDraftFormData

    } = useAppContext() as AppContextType

    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);
    const [submissive, setSubmissive] = useState<boolean>(false);



    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('raisonSociale')
        }
        else if (!statusSignatureValidity) {
            setActiveTab('signatureDesStatus')
        }
        else if (!theSociety) {
            setActiveTab('laSociété')
        }
        else if (!headOfficeAddressValidity) {
            setActiveTab('adresseDuSiegeSocial')
        }
        else if (!managers) {
            setActiveTab('laGérance')
        }
        return companyNameValidity && statusSignatureValidity && theSocietyValidity && headOfficeAddressValidity && managersValidity
    };

            const switchTab = (tab: string) => {
            setActiveTab(tab);
            };


    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const natureActText = statusSignature.actNature === "acte sous seing privé" ? 'acte SSP' : 'acte authentique'

            const tempText = `Par ${natureActText} du ${statusSignature.actDate},  il a été constitué une EURL ayant les caractéristiques suivantes :
Dénomination : ${companyName.companyName}${theSociety.acronym ? `,
Sigle: ${theSociety.acronym}` : ""},
Objet social : ${theSociety.object},
Siège social : ${headOfficeAddress.address} ${headOfficeAddress.additionalAddress ?? ""} ${headOfficeAddress.postalCode} ${headOfficeAddress.city},
Capital : ${theSociety.capital} €,
Durée : ${theSociety.duration > 1 ? `${theSociety.duration} ans` : `${theSociety.duration} an`},
Gérance : ${managers.map((manager: ManagerType, index: number) => {
                if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)},`
                }
                else if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city},`;
                }
            })}
Immatriculation au RCS ${getCityWithPreposition(headOfficeAddress.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'signatureDesStatus':
                return 'raisonSociale';
            case 'laSociété':
                return 'signatureDesStatus';
            case 'adresseDuSiegeSocial':
                return 'laSociété';
            case 'laGérance':
                return 'adresseDuSiegeSocial';
            default:
                return currentTab;
        }
    };
    
    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['raisonSociale', 'signatureDesStatus', 'laSociété', 'adresseDuSiegeSocial', 'laGérance'];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'raisonSociale':
                return 'signatureDesStatus';
            case 'signatureDesStatus':
                return 'laSociété';
            case 'laSociété':
                return 'adresseDuSiegeSocial';
            case 'adresseDuSiegeSocial':
                return 'laGérance';
            default:
                return currentTab;
        }
    };
    

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    const handleNext = () => {

        let draft = parseDraft()

        if (activeTab === 'raisonSociale') {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                const tempDraft = { ...draft, companyName }
                setDraftFormData( stringifyDraft( tempDraft ))
                switchTab(getNextTab('raisonSociale'))
            }
        } else if (activeTab === 'signatureDesStatus') {
            setStatusSignatureChecked(true)
            if (statusSignatureValidity) {
                const tempDraft = { ...draft, statusSignature }
                setDraftFormData( stringifyDraft( tempDraft ))
                switchTab(getNextTab('signatureDesStatus'))
            }
        } else if (activeTab === 'laSociété') {
            setTheSocietyChecked(true)
            if (theSocietyValidity) {
                const tempDraft = { ...draft, theSociety }
                setDraftFormData( stringifyDraft( tempDraft ))
                switchTab(getNextTab('laSociété'))
            }
        } else if (activeTab === 'adresseDuSiegeSocial') {
            setHeadOfficeAddressChecked(true)
            if (headOfficeAddressValidity) {
                const tempDraft = { ...draft, headOfficeAddress }
                setDraftFormData( stringifyDraft( tempDraft ))
                switchTab(getNextTab('adresseDuSiegeSocial'))
            }
        } else if (activeTab === 'laGérance') {
            setManagersChecked(true)
            if (managersValidity) {
                const tempDraft = { ...draft, managers }
                setDraftFormData( stringifyDraft( tempDraft ))
                setSubmissive(true)
            }
        }
    };

    return (
        <>
                {/* <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                </ul>
                </div> */}
            <TabsNavigation activeTab={activeTab} onTabClick={setActiveTab} />



            <form onSubmit={handleSubmit}>

                {/* Raison sociale */}
                {
                    activeTab === 'raisonSociale' &&
                    <CompanyName
                        changeCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                        checked={companyNameChecked}
                        companyName={companyName}
                        onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                    />
                }


                {/* signature des status */}
                {
                    activeTab === 'signatureDesStatus' &&
                    <StatusSignature
                        changeStatusSignature={(updatedData: Partial<StatusSignatureType>) => setStatusSignature({ ...statusSignature, ...updatedData })}
                        checked={statusSignatureChecked}
                        onValidationChange={(isValid: boolean) => setStatusSignatureValidity(isValid)}
                        statusSignature={statusSignature}
                    />
                }

                {
                    activeTab === 'laSociété' &&
                    <TheSociety
                        checked={theSocietyChecked}
                        companyName={companyName}
                        setTheSociety={setTheSociety}
                        societyType={["Entreprise unipersonnelle à responsabilité limitée"]}
                        theSociety={theSociety}
                        updateCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                        updateCompanyNameValidity={(isValid: boolean) => setCompanyNameValidity(isValid)}
                        updateTheSocietyValidity={(isValid: boolean) => setTheSocietyValidity(isValid)}
                    />
                }

                {
                    activeTab === 'adresseDuSiegeSocial' &&
                    <HeadOfficeAddress
                        changeHeadOfficeAddress={(updatedData: Partial<HeadOfficeAddressType>) => setHeadOfficeAddress({ ...headOfficeAddress, ...updatedData })}
                        checked={headOfficeAddressChecked}
                        headOfficeAddress={headOfficeAddress}
                        onValidationChange={(isValid: boolean) => setHeadOfficeAddressValidity(isValid)}
                    />
                }

                {
                    activeTab === 'laGérance' &&
                    <>
                        <ManagerList
                            addButtonText='Ajouter un gérant'
                            removeButtonText='Supprimer le dernier gérant'
                            checked={managersChecked}
                            managers={managers}
                            setManagers={setManagers}
                            setManagersValidity={setManagersValidity}
                            societyTypeOptions={Array.isArray(societyType) ? societyType : [societyType]}
                            draftFieldName = 'managers'
                        />
                        {
                            activeTab === 'laGérance' &&
                            submissive &&
                            <div className="mt-4">
                                <h4>Texte de l'annonce:</h4>
                                <textarea
                                    className="form-control"
                                    rows={8}
                                    value={txtAnnonce}
                                    disabled
                                />
                            </div>
                        }
                    </>
                }

                <div className='button-container'>
                    <div className="d-flex gap-2">
                        {activeTab !== 'raisonSociale' && (
                            <button
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        )}
                        {activeTab === 'laGérance' && (
                            <button type="submit" onClick={handleNext}>
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        )}
                        {activeTab !== 'laGérance' && (
                            <button
                                className="btn-add"
                                type="button"
                                onClick={handleNext}
                            >
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        )}
                        {submissive && activeTab === 'laGérance' && (
                            <button
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        )}
                    </div>
                </div>

            </form>

        </>
    );
};

export default CreationEURL;